export default __webpack_public_path__ + "static/hero-main-bg-desktop2-be981b40d57cc82451ef1d69ee3917a6.jpg";